'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('components');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./FineUploader.scss');

var UploaderItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(UploaderItem, _Component);

  function UploaderItem() {
    var _ref;

    (0, _classCallCheck3.default)(this, UploaderItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = UploaderItem.__proto__ || (0, _getPrototypeOf2.default)(UploaderItem)).call.apply(_ref, [this].concat(args)));

    _this.state = { uploadSuccess: false };
    _this._createEventHandlers();
    return _this;
  }

  (0, _createClass3.default)(UploaderItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.uploader.on('complete', this._onComplete);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unmounted = true;
      this._unregisterEventHandlers();
    }
  }, {
    key: '_unregisterEventHandlers',
    value: function _unregisterEventHandlers() {
      this.props.uploader.off('complete', this._onComplete);
    }
  }, {
    key: '_createEventHandlers',
    value: function _createEventHandlers() {
      var _this2 = this;

      this._onComplete = function (id, name, resp) {
        console.log(resp);
        if (id === _this2.props.id && !_this2._unmounted && resp.data.success) {
          _this2.setState({ uploadSuccess: true });
        }
      };
    }
  }, {
    key: 'uploaderThumbNode',
    value: function uploaderThumbNode() {
      var _props = this.props,
          id = _props.id,
          uploader = _props.uploader,
          maxSize = _props.maxSize;

      return _react2.default.createElement(_components.UploaderThumb, { id: id, uploader: uploader, maxSize: maxSize });
    }
  }, {
    key: 'fileExtNode',
    value: function fileExtNode() {
      var _props2 = this.props,
          id = _props2.id,
          uploader = _props2.uploader;

      return _react2.default.createElement(_components.FileName, { id: id, uploader: uploader, hideName: true });
    }
  }, {
    key: 'fileNameNode',
    value: function fileNameNode() {
      var _props3 = this.props,
          id = _props3.id,
          uploader = _props3.uploader;

      return _react2.default.createElement(_components.FileName, { id: id, uploader: uploader });
    }
  }, {
    key: 'uploadStatusNode',
    value: function uploadStatusNode() {
      var _props4 = this.props,
          id = _props4.id,
          uploader = _props4.uploader;

      return _react2.default.createElement(_components.UploadStatus, { id: id, uploader: uploader });
    }
  }, {
    key: 'fileSizeNode',
    value: function fileSizeNode() {
      var _props5 = this.props,
          id = _props5.id,
          uploader = _props5.uploader;

      return _react2.default.createElement(_components.UploaderFilesize, { id: id, uploader: uploader, className: styles.fileSize });
    }
  }, {
    key: 'progressBarNode',
    value: function progressBarNode() {
      var _props6 = this.props,
          id = _props6.id,
          uploader = _props6.uploader,
          altStyle = _props6.altStyle;

      return _react2.default.createElement(_components.ProgressBar, { id: id, uploader: uploader, className: styles.progressBar, altStyle: altStyle });
    }
  }, {
    key: 'uploadStatusIconNode',
    value: function uploadStatusIconNode() {
      var _props7 = this.props,
          id = _props7.id,
          uploader = _props7.uploader,
          cancelable = _props7.cancelable,
          deletable = _props7.deletable,
          onCancel = _props7.onCancel,
          onDelete = _props7.onDelete;

      return _react2.default.createElement(_components.UploadStatusIcon, {
        className: styles.statusIcon,
        cancelable: cancelable,
        deletable: deletable,
        id: id,
        uploader: uploader,
        onCancel: onCancel,
        onDelete: onDelete
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props8 = this.props,
          className = _props8.className,
          showOnSuccess = _props8.showOnSuccess,
          showThumb = _props8.showThumb;
      var uploadSuccess = this.state.uploadSuccess;


      return _react2.default.createElement(_components.UniversalUploaderItem, {
        className: (0, _classnames2.default)(className, { hidden: !showOnSuccess && uploadSuccess }),
        showThumb: showThumb,
        fileExtNode: this.fileExtNode(),
        fileNameNode: this.fileNameNode(),
        uploadStatusNode: this.uploadStatusNode(),
        fileSizeNode: this.fileSizeNode(),
        progressBarNode: this.progressBarNode(),
        uploadStatusIconNode: this.uploadStatusIconNode(),
        uploaderThumbNode: this.uploaderThumbNode()
      });
    }
  }]);
  return UploaderItem;
}(_react.Component), _class.propTypes = {
  altStyle: _propTypes2.default.bool,
  cancelable: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  deletable: _propTypes2.default.bool,
  id: _propTypes2.default.number.isRequired,
  maxSize: _propTypes2.default.number,
  onCancel: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  showOnSuccess: _propTypes2.default.bool,
  showThumb: _propTypes2.default.bool,
  uploader: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
  maxSize: 70
}, _temp);
exports.default = UploaderItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FineUploader/UploaderItem.js
// module id = 2006
// module chunks = 1